import { usePathname as useNextPathname } from 'next/navigation';
import { usePathname as useIntlPathname } from '@/i18n/routing';

// EWM-522 — `path` is the locale-stripped, mode-agnostic pathname from next-intl
// (no `/{locale}` on the shared origin, already clean on a per-locale domain).
// `absolutePath` is the raw pathname (carries the `/{locale}` prefix when there
// is one). This replaces the old `slice(2)` that assumed a leading locale
// segment — which is absent under domain (prefix-less) routing.
const usePath = () => {
  const absolutePath = useNextPathname();
  const path = useIntlPathname();
  const pathWithoutQuery = path.split('?')[0];

  return { path, absolutePath, pathWithoutQuery };
};
export default usePath;
